// Module
var code = "<script>let $ctrl</script> <molecule-form-edit> <organ-edit-panel-domain-locations-edit form-state=\"$ctrl.formState\" sortable-locations=\"$ctrl.sortableLocations\" non-sortable-locations=\"$ctrl.nonSortableLocations\" default-location=\"$ctrl.defaultLocation\"></organ-edit-panel-domain-locations-edit> </molecule-form-edit> ";
// Exports
module.exports = code;